/**
 * Component that shows/hides children changing the height from 0 to final value
 */

import React, {useEffect, useRef, useState} from 'react';

import styles from './SlideDownContent.module.scss';

const SlideDownContent = props => {
    const {isVisible, className = '', style = {}, children} = props,
        [height, setHeight] = useState(),
        ref = useRef();

    useEffect(() => {
        if (ref.current) {
            let height = ref.current.offsetHeight;
            // console.log('Updating height to', height);
            setHeight(height);
        }
    });

    // console.log('Using height: ', isVisible ? height : 0);

    return (
        <div className={[className, styles.SlideDownContent].join(' ')} style={{...style, height: isVisible ? height : 0}}>
            <div ref={ref}>{children}</div>
        </div>
    );
};

export default SlideDownContent;
